import { BONUSES_COST_KEY } from '@esentai/core/features/reconciliationRefunds/consts/keys';
import { TableCell, TableRow } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

import CondenseTableCell from '@/components/CondenseTableCell';

const HeadRow = ({ SortControl }) => (
  <TableRow>
    <TableCell>Магазин</TableCell>
    <TableCell>UUID</TableCell>
    <CondenseTableCell>
      <SortControl field={BONUSES_COST_KEY}>
        Сумма бонусов на возврат по чеку
      </SortControl>
    </CondenseTableCell>
  </TableRow>
);

HeadRow.propTypes = {
  SortControl: PropTypes.func.isRequired,
};

export default HeadRow;
